// @flow
import type { SampleList } from "../../lib/OnlineTypes";
import type { CompanyBranch } from "../../lib/Types";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import React, { Fragment } from "react";
import { DefaultPaddedContainer } from "../../styles/Theme";
import styled, { css } from "styled-components";
import Input from "../Input";
import Button from "../Button";
import { SingleDatePicker } from "react-dates";
import { fetchJson } from "../../lib/Fetching";
import MatrixInput from "../testing/MatrixInput";
import moment from "moment";
import CompanyBranchDropDown from "../crm/CompanyBranchDropDown";
import DropDown from "../DropDown";
import RadioButtons from "../RadioButtons";
import CompanyDropDown from "../crm/CompanyDropDown";
import ScheduledFilter from "./ScheduledFilter";
import TestingCategorySelect from "./TestingCategorySelect";
import ReceivedStatus from "../common/form/ReceivedStatus";
import SearchTemplateManager from "../common/SearchTemplateManager";

type Props = {
  laboratory_company_id: number,
  onSearch: (SampleList) => void,
  initialFormParams: Object,
  runSearch: boolean,
  hideForm: boolean,
};

type State = {
  lastSuccessfulSearch: ?Object,
  company_id: ?number,
  loading: boolean,
  company_branch_id: ?number,
  client_company_branch_id: ?number,
  start_date: ?Object,
  end_date: ?Object,
  startDateFocused: boolean,
  endDateFocused: boolean,
  received: string,
  sentStatus: string,
  testingCategory: ?number,
  matrixId: ?number,
};

const Container = styled.div.attrs({
  className: "form-panel with-padding",
})``;

const Row = styled.div.attrs({ className: "row" })`
  padding-bottom: 10px;
`;

const Column = styled.div.attrs({ className: "col-md-4" })``;
const FullColumn = styled.div.attrs({ className: "col-md-12" })``;

export default class SampleSearch extends React.Component<Props, State> {
  state = {
    lastSuccessfulSearch: null,
    company_id: this.props.initialFormParams ? this.props.initialFormParams.company_id : null,
    testingCategory: this.props.initialFormParams ? this.props.initialFormParams.testing_category : null,
    sample_ids: this.props.initialFormParams ? this.props.initialFormParams.sample_ids : null,
    loading: false,
    company_branch_id: null,
    client_company_branch_id: this.props.initialFormParams
      ? this.props.initialFormParams.company_branch_id
      : null,
    start_date:
      this.props.initialFormParams && this.props.initialFormParams.start_date
        ? moment.utc(this.props.initialFormParams.start_date)
        : moment().subtract(10, "days"),
    end_date:
      this.props.initialFormParams && this.props.initialFormParams.end_date
        ? moment.utc(this.props.initialFormParams.end_date)
        : moment(),
    startDateFocused: false,
    endDateFocused: false,
    received:
      this.props.initialFormParams && this.props.initialFormParams.laboratory_sample_received
        ? this.props.initialFormParams.laboratory_sample_received
        : "not_received",
    sentStatus: "all"
  };

  formKey = "sample_reception/sample_search"

  getSearchParams = () => {
    const s = this.state;
    const p = this.props;
    return {
      company_id: s.company_id || null,
      testing_category_id: s.testingCategory || null,
      company_branch_id: s.company_branch_id || null,
      client_company_branch_id: s.client_company_branch_id || null,
      received: s.received,
      sent_status: s.sentStatus,
      start_date: s.start_date ? s.start_date.format("YYYY-MM-DD") : null,
      end_date: s.end_date ? s.end_date.format("YYYY-MM-DD") : null,
      matrix_id: s.matrixId || null,
    }
  }

  applyTemplate = (tpl) => {
    const next = {};
    if ("company_id" in tpl) next.company_id = tpl.company_id || null;
    if ("testing_category_id" in tpl) next.testingCategory = tpl.testing_category_id || null;
    if ("company_branch_id" in tpl) next.company_branch_id = tpl.company_branch_id || null;
    if ("client_company_branch_id" in tpl) next.client_company_branch_id = tpl.client_company_branch_id || null;
    if ("received" in tpl) next.received = tpl.received || "not_received";
    if ("sent_status" in tpl) next.sentStatus = tpl.sent_status || "all";
    if ("start_date" in tpl) next.start_date = tpl.start_date ? moment(tpl.start_date) : null;
    if ("end_date" in tpl) next.end_date = tpl.end_date ? moment(tpl.end_date) : null;
    if ("matrix_id" in tpl) next.matrixId = tpl.matrix_id || null;
    this.setState(next);
  }

  componentDidMount() {
    if (this.props.runSearch) {
      this.findSamples();
    }
  }

  canSubmit = (): boolean => {
    const { start_date, end_date } = this.state;
    if (!start_date || !end_date) return false;
    if (end_date < start_date) return false;
    return true;
  };

  performLastSearch = () => {
    const { lastSuccessfulSearch } = this.state;
    if (!lastSuccessfulSearch) {
      return;
    }
    this.fetchSamples(lastSuccessfulSearch);
  };

  findSamples = () => {
    const { laboratory_company_id } = this.props;
    const {
      company_id,
      start_date,
      end_date,
      company_branch_id,
      received,
      sentStatus,
      client_company_branch_id,
      sample_ids,
      testingCategory,
      matrixId,
    } = this.state;

    const searchParams = {
      company_id,
      form: {
        company_ids: company_id ? [company_id] : [],
        start_date: start_date ? start_date.format("YYYY-MM-DD") : null,
        end_date: end_date ? end_date.format("YYYY-MM-DD") : null,
        company_branch_id: client_company_branch_id,
        laboratory_sample_company_id: laboratory_company_id,
        laboratory_sample_branch_id: company_branch_id,
        laboratory_sample_received: received,
        laboratory_sample_sent: sentStatus,
        include_laboratory_samples: true,
        testing_category_id: testingCategory,
        matrix_id: matrixId,
        sample_ids: sample_ids || [],
      },
    };
    this.fetchSamples(searchParams);
  };
  fetchSamples = (searchParams) => {
    const { onSearch } = this.props;
    this.setState({ loading: true });
    onSearch(null);
    fetchJson("/sample_reception/laboratory_samples.json", searchParams)
      .then((json) => {
        console.log(json);
        this.setState({ loading: false, lastSuccessfulSearch: searchParams });
        onSearch(json.sample_list);
      })
      .catch((e) => {
        alert("There was an error loading the samples.");
        this.setState({ loading: false });
      });
  };

  branchChanged = (branch: CompanyBranch) => {
    this.setState({ company_branch_id: branch ? branch.id : undefined });
  };

  clientBranchChanged = (branch: CompanyBranch) => {
    this.setState({ client_company_branch_id: branch ? branch.id : undefined });
  };

  render() {
    const { laboratory_company_id, initialFormParams, hideForm } = this.props;

    if (hideForm) return null;

    const {
      company_id,
      loading,
      start_date,
      end_date,
      startDateFocused,
      endDateFocused,
      company_branch_id,
      client_company_branch_id,
      received,
      sentStatus,
      testingCategory,
      matrixId,
    } = this.state;
    console.log(this.state);
    const receivedOptions = [
      { label: "Show All", value: "all" },
      { label: "Not Received", value: "not_received" },
      { label: "Received", value: "received" },
    ];
    const sentOptions = [
      { label: "Show All", value: "all" },
      { label: "Not Sent", value: "not_sent" },
      { label: "Sent", value: "sent" },
    ];
    const scheduledOptions = [
      { label: "Show All", value: "all" },
      { label: "Not Scheduled", value: "unscheduled" },
      { label: "Scheduled", value: "scheduled" },
    ];
    return (
      <Container>
        <Row>
          <Column>
            <label>{I18n.t("testing_category")}</label>
            <TestingCategorySelect
              value={testingCategory}
              onChange={(o) => this.setState({ testingCategory: o.value })}
            />
          </Column>
        </Row>
        <Row>
          <Column>
            <label>Receiving Lab Branch</label>
            <CompanyBranchDropDown
              company_id={laboratory_company_id}
              onBranchChange={this.branchChanged}
              value={company_branch_id}
              includeBlank={true}
              blankLabel={"All Branches"}
            />
          </Column>
          <Column>
            <label>{I18n.t("client_company")}</label>
            <CompanyDropDown
              value={company_id}
              initialOptions={
                initialFormParams
                  ? [
                      {
                        value: initialFormParams.company_id,
                        label: initialFormParams.company_name,
                      },
                    ]
                  : null
              }
              onChange={(company_id) =>
                this.setState({ company_id, client_company_branch_id: null })
              }
            />
          </Column>
          <Column>
            <label>{I18n.t("client_branch")}</label>
            <CompanyBranchDropDown
              key={company_id}
              company_id={company_id}
              onBranchChange={this.clientBranchChanged}
              value={client_company_branch_id}
              includeBlank={true}
              blankLabel={"All Branches"}
            />
          </Column>
        </Row>
        <Row>
          <Column>
            <ReceivedStatus
              onChange={(value) => this.setState({ received: value })}
              value={received}
            />
          </Column>
          <Column>
            <label>Sent Status</label>
            <br />
            <RadioButtons
              name="sent"
              onChange={(dropDownItem) => this.setState({ sentStatus: dropDownItem.value })}
              options={sentOptions}
              value={sentStatus}
            />
          </Column>
        </Row>
        <Row>
          <Column>
            <label>Registered After</label>
            <br />
            <SingleDatePicker
              numberOfMonths={1}
              date={start_date}
              onDateChange={(date) => this.setState({ start_date: date })}
              focused={startDateFocused}
              onFocusChange={({ focused }) => this.setState({ startDateFocused: focused })}
              id="start_date"
              showClearDate={true}
              isOutsideRange={() => false}
              hideKeyboardShortcutsPanel={true}
              displayFormat="DD MMM YYYY"
            />
          </Column>
          <Column>
            <label>Registered Before</label>
            <br />
            <SingleDatePicker
              numberOfMonths={1}
              date={end_date}
              onDateChange={(date) => this.setState({ end_date: date })}
              focused={endDateFocused}
              onFocusChange={({ focused }) => this.setState({ endDateFocused: focused })}
              id="end_date"
              showClearDate={true}
              isOutsideRange={() => false}
              hideKeyboardShortcutsPanel={true}
              displayFormat="DD MMM YYYY"
            />
          </Column>
          <Column>
            <label>{I18n.t("matrix")}</label>
            <MatrixInput
              multiple={false}
              value={matrixId ? [matrixId] : []}
              onChange={(option) => this.setState({ matrixId: option ? option.value : null })}
              defaultStyle
            />
          </Column>
        </Row>
        <Row style={{ paddingBottom: 0, paddingTop: 5 }}>
          <FullColumn style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Button
              disabled={!this.canSubmit()}
              title={loading ? "Loading..." : "Show Samples"}
              icon="fa-search"
              onClick={this.findSamples}
            />
            <SearchTemplateManager
              formKey={this.formKey}
              getCurrentParams={this.getSearchParams}
              applyTemplate={this.applyTemplate}
            />
          </FullColumn>
        </Row>
      </Container>
    );
  }
}
